// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3GiNC","error":"Textarea_error__2Ngk3","readonly":"Textarea_readonly__3gT0A","disabled":"Textarea_disabled__3bRIp"};